import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [showDialog, setShowDialog] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('https://xcelitsolutions.co.uk/forgot_password.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (data.status === 'success') {
        setMessage(data.message);
        setShowDialog(true); // Show the dialog
      } else {
        alert(data.message || 'Failed to send reset email.');
      }
    } catch (error) {
      console.error('Fetch error:', error);
      setMessage('Something went wrong. Please try again later.');
      setShowDialog(true); // Optionally show dialog for error
    }
  };

  const handleDialogClose = () => {
    setShowDialog(false);
    navigate('/tempLogin');
  };

  return (
    <div style={{ maxWidth: '400px', margin: 'auto', padding: '20px' }}>
      <h2>Forgot Password</h2>
      <form onSubmit={handleSubmit}>
        <h6>Please enter your registered email below.</h6>
        <label>Email: </label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <br />
        <button type="submit">Continue</button>
      </form>

      {/* Dialog Box */}
      {showDialog && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              background: 'white',
              padding: '20px',
              borderRadius: '10px',
              maxWidth: '300px',
              textAlign: 'center',
            }}
          >
            <p>{message}</p>
            <button onClick={handleDialogClose}>Okay</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ForgotPassword;
